import React from 'react';
import {
  TableCell as MuiTableCell,
  TableRow as MuiTableRow,
  useTheme,
} from '@mui/material';
import type { Cell, Row } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';

const TableRow = ({ row }: TableRowProps) => {
  const theme = useTheme();
  return (
    <MuiTableRow
      key={row.id}
      sx={{
        boxShadow: '1px 1px 2px 0 rgba(0, 0, 0, 0.09)',
        border: `1px solid ${theme.serviceTable.cell.borderColor}`,
        ':hover': {
          backgroundColor: `${theme.serviceTable.cell.hoverBgColor}`,
        },
      }}
    >
      {row.getVisibleCells().map((cell) => (
        <TableCell cell={cell} key={cell.id} />
      ))}
    </MuiTableRow>
  );
};

export default TableRow;

type TableRowProps = {
  row: Row<unknown>;
};

const TableCell = ({ cell }: TableCellProps) => {
  return (
    <MuiTableCell
      sx={{
        padding: '1rem 1.333rem',
        fontSize: 14,
        lineHeight: '20px',
        fontWeight: 400,
        borderBottomWidth: '1px',
        color: (theme) => theme.serviceTable.cell.color,
        width: cell.column.getSize(),
        minWidth: cell.column.getSize(),
      }}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </MuiTableCell>
  );
};

type TableCellProps = {
  cell: Cell<unknown, unknown>;
};
